import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { Paged } from "../../../utils/backend-types";
import type { SiteSetupProcessTileData } from "../StartPage.types";

function useStartPageSiteSetupProcesses(
  page: number,
  pageSize: number,
  projectId?: string
) {
  return useQuery({
    queryKey: urls.startPage.siteSetupProcesses.key({
      page,
      pageSize,
      projectId
    }),
    queryFn: () => fetchStartPageSiteSetupProcesses(page, pageSize, projectId)
  });
}

async function fetchStartPageSiteSetupProcesses(
  page: number,
  pageSize: number,
  projectId?: string
) {
  const response = await apiWithoutCamelization.get<
    Paged<SiteSetupProcessTileData>
  >(urls.startPage.siteSetupProcesses.url({ page, pageSize, projectId }));
  return response.data;
}

export { useStartPageSiteSetupProcesses };
